<!-- 终于，专家研究发现了孩子学英语的关键期 -->
<template>
  <div class="rich_media_content " id="js_content">
    <h2 style="text-align:center">终于，专家研究发现了孩子学英语的关键期！</h2>
    <p style="text-align:center;font-size:10pt"><span style="color:gray">来自 </span><span style="color:blue">不务正业的算法工程师</span></p>
    <img data-type="gif" data-src="../../../static/images/51talk_small.gif" data-copyright="0" width="100%"
      class=" __bg_gif" src="../../../static/images/51talk_small.gif" data-order="0" data-fail="0">
    <p><strong >请注意, 本文信息量3200字, 阅读时长约15-20分钟</strong></p>
    <p>
      读完本文，您可以刷新以下几点认知：
      <ol>
        <li>每个人都是多元智能体，且在语言、词汇、语法、情绪、运动、数学逻辑、音乐等多方面上都有着不同的关键期</li>
        <li>语言学习的许多方面都存在<strong>效率和年龄相反</strong>的关系</li>
        <li>人类拥有语言学习的敏感期跟大脑发展过程息息相关，综合语言学习的语音、语法、词汇各方面敏感期，得出孩子学习英语在<strong>3-6岁</strong>比较合理</li>
        <li><strong>儿童相比大人学习第二语言的大脑处理区完全不同</strong>，儿童的优势在于语言知识表征能力和语音优势等，这并不代表儿童学得比成人快，但最终的英语能力比成人好</li>
        <li>第二语言的学习，<strong>什么时候开始，如何开始和以什么方式开始一样重要</strong></li>
      </ol>
      <span style="color:#3f3f3f;font-size: 12px;color: #888888;">-------------------------------------------------------------------</span>
    </p>
    <!-- <p style="text-align:center; color: red;">&nbsp;*****</p> -->
    <section class="" data-tools="135编辑器" data-id="91660" style="font-size: 16px;border-width: 0px;border-style: none;border-color: initial;box-sizing: border-box;" data-color="rgb(255, 232, 0)">
      <section data-role="paragraph" class="" style="border-width: 0px;border-style: none;border-color: initial;box-sizing: border-box;" data-color="rgb(255, 232, 0)">
        <section style="padding: 10px;box-sizing: border-box;">
          <section style="width: 100%;" data-width="100%">
            <section style="width: 36px;height: 36px;margin-right: auto;margin-left: auto;background-color: rgb(107, 107, 107);border-width: 1px;border-style: solid;border-color: transparent;box-sizing: border-box;">
              <section style="width: 0px;height: 0px;border-width: 5px 4px;border-style: solid;border-color: transparent transparent rgb(107, 107, 107) rgb(107, 107, 107);float: right;margin-right: -8px;margin-top: -2px;box-sizing: border-box;"></section>
              <section style="width: 36px;height: 36px;border-width: 2px;border-style: solid;border-color: rgb(107, 107, 107);background-color: rgb(255, 232, 0);margin-top: 8px;margin-left: 8px;text-align: center;font-size: 20px;color: rgb(255, 255, 255);font-weight: 600;line-height: 36px;overflow: hidden;box-sizing: border-box;">
                <p class="" data-brushtype="text" data-original-title="" title=""></p>
              </section>
              <section style="width: 0px;height: 0px;border-width: 5px;border-style: solid;border-color: rgb(107, 107, 107) rgb(107, 107, 107) transparent transparent;margin-top: -10px;margin-left: -1px;box-sizing: border-box;"></section>
            </section>
          </section>
        </section>
      </section>
    </section>
  
    <h3 style="text-align:center">孩子哪些技能的发展有关键期？</h3>
    <p>关键期这一概念最初是由奥地利生态学家康罗德·洛伦兹(1937)提出来的。他在对鸟类自然习性的观察中，发现刚孵出的幼鸟，如小鸡、小鹅等，会在出生后很短的一段时间内学会追逐自己的同类或非同类，过了这段时间便再也不能学会此类行为或印刻自己的母亲，而这段时间是很短的，故称为人类的关键期，又称最佳期、敏感期、临界期、转折期。后来，心理学家将这类研究借用到儿童早期发展的研究中，提出了儿童心理发展的关键期问题。如2～3岁是儿童口头语言发展的关键期，4～5岁是儿童学习书面语言的关键期等</p>
    <p><span style="line-height: 1.6;">而关键期这个真的存在吗？孩子是如何在各个时期发展的呢？美国著名的发展心理学教授霍华德•加德纳提出了多元智能理论(Frame of mind,1983)，认为人类的智能是多元的，但几乎每个人都是聪明的，只是聪明的定义不一样，每个人的智能图谱都不一致，这个智能的形成和发展也不完全是天生的，也依赖后天的环境和教育音素，需要经过学习实践来提升。而孩子发展了什么样的智能对于未来能承担什么类型的工作也息息相关。Gardner在1995年对多元智能理论进行了深化，加入了“自然认知智能”，合起来为以下的八个：</span>
      <ul>
        <li><strong>语言智能</strong>:有效运用口语和书写能力</li>
        <li><strong>数学逻辑智能</strong>:数学、逻辑和科学分析能力，比如科学家、律师、数学家</li>
        <li><strong>身体运动智能</strong>:能够利用身体的一部分解决和制造产品的能力，比如运动员、舞蹈家</li>
        <li><strong>人际情绪智能</strong>:能够察觉并区分他人的情绪意向、动机以及感觉得能力，比如谈判官</li>
        <li><strong>视觉空间智能</strong>:在脑中形成一个外部空间模式，并能够利用和操作这种能力，比如画家、设计师</li>
        <li><strong>音乐艺术智能</strong>:能够察觉、辨别、改变和表达创造音乐的能力，比如歌唱家</li>
        <li><strong>自我认知智能</strong>:能够建立准确而真实的自省模式并在实际生活中有效运用，比如文学家、心理学家等</li>
        <li><strong>自然认知智能</strong>:能够准确进行自然探索并有效运用，如探险家</li>
      </ul>
    关键期表明了儿童发展的几个重要时期，在此期间，脑对各种类型的信息输入产生反映，以创造或巩固神经网络。在关键期中，大脑要求某些特定类型的信息输入，以形成或巩固长期保持的结构，在关键期学习相应的技能就容易掌握，以上的多元智能中，有几个智能在研究中发现了关键期：
    <ul>
      <li><strong>语言智能</strong>:0-10岁</li>
      <li><strong>数学逻辑智能</strong>:1-4岁</li>
      <li><strong>身体运动智能</strong>:0-6岁</li>
      <li><strong>人际情绪智能</strong>:2个月-2.5岁</li>
      <li><strong>视觉空间智能</strong>:0-2岁</li>
      <li><strong>音乐艺术智能</strong>:3-10岁</li>
      <li><strong>规则意识</strong>:2.5-3.5岁</li>
    </ul>
    </p>
    <p><span>对于上面关键期的理解举个例子，即使儿童的脑是正常的，如果在两岁之前，没有接受视觉刺激（比如一出生就给戴上眼罩），那么就会永久性失明（给它摘下眼罩莱它也看不见东西）。如果在10岁之前没有听到字词，那么将无法学习语言。当这些关键期过去后，执行这些任务的脑细胞将失去这种能力。但过了关键期，这些方面在以后的生活中仍然可以学习，但是发展水平可能会受到极大的限制。而对于语言的研究中，也存在同样的趋势——早期学者提出语言习得有关键期，<span style="color: rgb(0, 180, 238);">基于大脑的可塑性，近期一些研究者把青春期前（11岁至12岁前后进入青春期）的这段时间看成是语言习得的敏感期</span>，而非关键期（Newport, Bavelier, and Neville, 2001; Schumann, 1997）。但是，需要注意的是，大脑处于“敏感期”期间的敏感程度并不一致，越接近12岁，对于新语言的敏感程度越呈现逐渐降低的趋势。</span>
    </p>
    <p><span>也就是说，对于一种新的语言，人类在任何时间都可以学习、也都可以学得会，但是学习的难易程度会存在差异。用一个简单的比喻，类似于打游戏的时候往往有Easy和Hard模式供选择，<span style="color: rgb(0, 180, 238);">如果尽早学习一种新的语言（例如，英语），就是为孩子选择了“Easy”模式，学习起来事半功倍。</span></span>
    </p>
    <img data-w="" data-ratio="0.5625" title="大脑神经剪枝过程" src="../../../static/images/pruning.jpg">
    </p>
    <!-- <p style="text-align:center;color: red;">&nbsp;*****</p> -->
  
    <section class="" data-tools="135编辑器" data-id="91660" style="font-size: 16px;border-width: 0px;border-style: none;border-color: initial;box-sizing: border-box;" data-color="rgb(255, 232, 0)">
      <section data-role="paragraph" class="" style="border-width: 0px;border-style: none;border-color: initial;box-sizing: border-box;" data-color="rgb(255, 232, 0)">
        <section style="padding: 10px;box-sizing: border-box;">
          <section style="width: 100%;" data-width="100%">
            <section style="width: 36px;height: 36px;margin-right: auto;margin-left: auto;background-color: rgb(107, 107, 107);border-width: 1px;border-style: solid;border-color: transparent;box-sizing: border-box;">
              <section style="width: 0px;height: 0px;border-width: 5px 4px;border-style: solid;border-color: transparent transparent rgb(107, 107, 107) rgb(107, 107, 107);float: right;margin-right: -8px;margin-top: -2px;box-sizing: border-box;"></section>
              <section style="width: 36px;height: 36px;border-width: 2px;border-style: solid;border-color: rgb(107, 107, 107);background-color: rgb(255, 232, 0);margin-top: 8px;margin-left: 8px;text-align: center;font-size: 20px;color: rgb(255, 255, 255);font-weight: 600;line-height: 36px;overflow: hidden;box-sizing: border-box;">
                <p class="" data-brushtype="text" data-original-title="" title=""></p>
              </section>
              <section style="width: 0px;height: 0px;border-width: 5px;border-style: solid;border-color: rgb(107, 107, 107) rgb(107, 107, 107) transparent transparent;margin-top: -10px;margin-left: -1px;box-sizing: border-box;"></section>
            </section>
          </section>
        </section>
      </section>
    </section>
  
    <h3 style="text-align:center">外语教学开展越早，学习的效率和效果就越好</h3>
    <p><span>大脑在生理上为语言的获得做好了准备，即大脑从生命的一开始就具有学习语言的能力，但是语言获得的过程需要经验的促进作用（即不断地进行练习的过程，听说能力需要不断在情境中听和说，读写能力需要大量的阅读和写作的专门训练）。在个体发展的特定阶段，语言发展存在着敏感期（即发展机遇期），敏感期内语言功能回路最容易发生经验依赖性的变化（在练习中逐渐形成内化，可以实现随时随地的精确调用）。在语言学习的许多方面，年龄与学习效果之间成反比。一般而言，接触语言的年龄越小，学习越成功。认知神经科学确定，幼儿与更成熟的人相比，大脑是以不同的方式来加工语言的，且对这两种不同的加工机制有了深入的了解。这种理解与教育政策是相关的，尤其是外语教学，常常到青少年期才开始。<span style="color:rgb(0, 180, 238);">青少年和成年人当然也可以学会一种新的语言，但是更加困难</span>。</span>
    </p>
  
    <p>
      Jacqueling Johnson和Newport的研究发现，从3岁到7岁开始说英语的移民者和母语是英语的人说话很像，不带有明显口音。8岁—12岁期间开始讲第二语言者，其熟练水平相当于母语者的80%；11岁-15岁开始学习的，其熟练水平仅有母语者的一半，而17岁以后开始的，仅有出生于美国本土人平均熟练程度的15%。这些数据表明，获得语言的机会之门在青春期之后逐渐关闭。到成人阶段仍可能学会第二语言，但是要困难的多。对于大多数人来说，青春期以后，负责语言获得的脑区不再对其他语言的语音有反应。因此，就要由其他的脑区来负责识别外语中的语音并作出反应。FMRI脑成像研究结果也显示，成人获得第二语言的脑区与母语者获得第一语言的脑区是不同的:
      <img data-w="" data-ratio="0.5625" title="敏感期" src="../../../static/images/john_peroid.jpg">
      <section style="height: 25px;box-sizing: border-box;color: inherit;">
        <section style="height: 100%;width: 50px;float: left;border-top-width: 2px;border-top-style: solid;border-color: rgb(0, 180, 238);border-left-width: 2px;border-left-style: solid;box-sizing: border-box;color: inherit;"></section>
        <section style="display: inline-block;color: rgb(0, 180, 238);clear: both;box-sizing: border-box;border-color: rgb(172, 29, 16);"></section>
      </section>
    <blockquote>
      <span style="font-size: 14px; color: rgb(0, 180, 238);">1-3岁</span>的时候将小孩放在外语环境中，大脑就会运用左半球加工语法信息，就像母语者一样；但只要将时间往后推到<span style="font-size: 14px; color: rgb(0, 180, 238);">4-6岁</span>学习外语，就意味着脑要通过两个半球来加工语法信息,当孩子在11岁、12岁或13岁的时候才第一次接触外语时，也就是说在上中学的时候开始接触外语，脑成像研究发现其激活模式已经发生异常</blockquote>
    <section style="height: 25px;box-sizing: border-box;color: inherit;">
      <section style="height: 100%;width: 50px;float: right;border-bottom-width: 2px;border-bottom-style: solid;border-color: rgb(0, 180, 238);border-right-width: 2px;border-right-style: solid;box-sizing: border-box;color: inherit;"></section>
    </section>
    </p>
  
    <p>
    所以，<strong>儿童和成人的脑对第二语言学习的处理器是完全不同的</strong>，延迟接触语言会导致脑使用不同的策略来加工语法信息。而<strong>儿童体现出的语言优势不只是语言加工问题，还和语言知识如何表征密切相关</strong>(Dekeyser 2012)，如果在青春期以前就获得第二语言的话，母语和第二语言的表征区域就都在额叶（布洛卡Broca区），较晚接触第二语言会导致语法加工能力的严重缺陷（Fledge and Fletcher，1992）。如此看来，语法学习模式表现为，越早接触第二语言可以形成高效的语法加工策略.但这并不代表儿童比成人学习速度快，反而是成人学习速度快，但是<strong>儿童最终英语能力比成人好</strong>(Dekeyser 2012)。
    </p>
  
    <p><span>而语言学习涵盖了语音、词汇、语法、语义等，不同的模块是否包含相关的关键期？据Kuhl教授研究，<strong>语音敏感期其实发生在从出生到10个月</strong>，此时的大脑最容易获得所处语言环境的语音原型。语法学习同样存在着发展敏感期：语言学习越早，大脑就能越有效地掌握这门语言的语法（Nevilleand Bruner，2001）；同时，Dekeyser 2010的研究也发现0-80岁都显示出了明显的年龄效应，且在<strong>18岁以后的二语学习开始有一个比较陡的学习成绩的下滑</strong>（Dekeyser 进行了两个平行对照研究，一组是俄罗斯人在以色列学希伯来语，另外一组是俄罗斯人在美国学习英语，以考察他们的年龄效应）。另外，口音的获得也有敏感期（Neville and Bruner，2001）。但令人欣慰的是，Dekeyser在综述中表达了<strong>词汇习得可能更少受年龄效应的影响</strong>，而这个结论在Ullman的脑电和核磁实验中也得到了验证，即：成人的第二语言学习词汇在大脑中储存的位置或词汇通达的脑电成分和母语者一致，说明词汇量上是可以达到母语水平的。</span>
    </p>
    <p><img data-w="" data-ratio="0.5625" title="敏感期" src="../../../static/images/2010peroid.jpg"></p>
  
    <p>总的来说，语言学习的许多方面都存在效率和年龄相反的关系——一般而言，越早接触语言，就能学得更好。根据上述基于认知神经科学与学习的研究可以发现，<span style="color: rgb(0, 180, 238);">由于语言本身的高度复杂性，虽然语言发展存在着敏感期（即发展机遇期），但是在语音、口音、语法等语言要素方面，人脑发展出的与之配合的特定结构存在着先后上的不一致，综合得出一个大致的年龄应该是在6岁之前，3岁之后较为合理</span></p>
  
    <!-- <p style="text-align:center; color: red;">&nbsp;*****</p> -->
    <section class="" data-tools="135编辑器" data-id="91660" style="font-size: 16px;border-width: 0px;border-style: none;border-color: initial;box-sizing: border-box;" data-color="rgb(255, 232, 0)">
      <section data-role="paragraph" class="" style="border-width: 0px;border-style: none;border-color: initial;box-sizing: border-box;" data-color="rgb(255, 232, 0)">
        <section style="padding: 10px;box-sizing: border-box;">
          <section style="width: 100%;" data-width="100%">
            <section style="width: 36px;height: 36px;margin-right: auto;margin-left: auto;background-color: rgb(107, 107, 107);border-width: 1px;border-style: solid;border-color: transparent;box-sizing: border-box;">
              <section style="width: 0px;height: 0px;border-width: 5px 4px;border-style: solid;border-color: transparent transparent rgb(107, 107, 107) rgb(107, 107, 107);float: right;margin-right: -8px;margin-top: -2px;box-sizing: border-box;"></section>
              <section style="width: 36px;height: 36px;border-width: 2px;border-style: solid;border-color: rgb(107, 107, 107);background-color: rgb(255, 232, 0);margin-top: 8px;margin-left: 8px;text-align: center;font-size: 20px;color: rgb(255, 255, 255);font-weight: 600;line-height: 36px;overflow: hidden;box-sizing: border-box;">
                <p class="" data-brushtype="text" data-original-title="" title=""></p>
              </section>
              <section style="width: 0px;height: 0px;border-width: 5px;border-style: solid;border-color: rgb(107, 107, 107) rgb(107, 107, 107) transparent transparent;margin-top: -10px;margin-left: -1px;box-sizing: border-box;"></section>
            </section>
          </section>
        </section>
      </section>
    </section>
  
    <h3 style="text-align:center">人类为什么会存在语言学习的敏感期？</h3>
    <p><span>为了解答这个问题，就需要深入了解人类大脑的发育过程。</span></p>
    <p><span>相对于婴儿期来说，童年时期（3-12岁，包括童年早期、童年中期）的大脑发育并没有那么明显，但是，该阶段也出现了一些重要的变化。其中一个变化是大脑皮层某些区域内灰质密度下降（神经元细胞体的紧密结合），这个过程反应了无用树突的精简与大脑白质的稳定增加互相平衡。在儿童6-13岁期间，大脑颞叶和顶叶之间的联结迅速发展（顶叶是负责处理感觉信息、语言和空间理解的脑区）。在语言学习敏感期结束之后，这些区域内白质的生长速度也相应下降（Giedd et al., 1999; Kuhn, 2006; NIMH, 2001b; Paus et al., 1999）。所有这些改变都是为了提高大脑的加工速度和效率。</span></p>
    <p><span>大脑白质的髓鞘化过程是从前往后进行的，然而灰质的减少似乎正好遵循相反的顺序。在对13名儿童从4岁到21岁进行的追踪研究发现，灰质的减少开始于4-8岁之间，主要是从控制基本的感觉和运动活动的区域开始；然后，大约在11-13岁的时候，按照从后到前的方向逐渐移动到控制注意力、语言和空间定位能力的顶叶区域，最后，在青春期晚期到达控制推理和其它更高级功能的前额叶皮层区域。这个顺序大体上与人类进化过程中这些大脑部位的发展进程是一致的（Gogtay et al., 2004）。</span></p>
  
    <p><img data-w="" data-ratio="0.5625" title="大脑发展" src="../../../static/images/brain.jpg"></p>
    <p><span>大脑发育的变化也体现在胼胝体上，即连结大脑左半球和右半球的组织。胼胝体内纤维髓鞘化的发展导致了大脑左右半球之间信息传递速度的加快（Toga et al., 2006）。对3-15岁儿童的胼胝体进行追踪绘图，研究者发现了一种从前往后的发展模式（Thompson, et al., 2000）。3-6岁期间的儿童发展最迅速的脑区是管理计划和组织行为的前额叶脑区；6-11岁期间的儿童发展最迅速的脑区主要集中在支持联想思维、语言和空间关系的区域。这种发展在11-15岁的时候逐渐减慢，这可能与我们所了解的学习一种新语言的敏感期结束相吻合。</span></p>
    <p><span style="color: rgb(0, 180, 238);">简单地说，童年早期（3-6岁）对于人类而言，一种新语言的习得机制依然与母语的习得机制高度一致，在这个时间学习一种新语言是最能够取得最好的学习的效率和效果<strong>。</strong>人类的大脑为了能够更好地发展，伴随着认知复杂性的增加大脑需要开始进行无用树突的精简，即切断一些树突、减少能量损耗，转移至更高级的认知功能的发展。这个过程阻碍了青少年或成人学习一种新语言的能力。另外，年幼儿童是一点一点地获得语言，这样很容易消化吸收。年龄大的学习者在开始学习语言时，倾向于一次性接受很多，这样在之后分析解释时就会遇到困难（Newport, 1991）。但总的来说第二语言的学习，<strong>什么时候开始，如何开始和以什么方式开始一样重要.</strong></span></p>
    <p><span>&nbsp;</span></p>
  
    <p><strong style="color:black">参考资料：</strong>
    <br>
    <span>-<span style="font-stretch: normal; font-size: 9px; line-height: normal;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>《中国学前教育百科全书》心理发展卷，1984年，沈阳出版社；</span>
  
    <span>-<span style="font-stretch: normal; font-size: 9px; line-height: normal;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>《理解脑——新的学习科学的诞生》，2010年，教育科学出版社；</span>
  
    <span>-<span style="font-stretch: normal; font-size: 9px; line-height: normal;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>《人脑的教育》，2011年，教育科学出版社；</span>
    <br>
    <span>-<span style="font-stretch: normal; font-size: 9px; line-height: normal;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>《孩子的世界——从婴儿期到青春期(第11版)》，2013年，人民邮电出版社；</span>
    <br>
    <span>-<span style="font-stretch: normal; font-size: 9px; line-height: normal;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>《儿童心理学——0-8岁儿童的成长》，2015年，机械工业出版社。</span></p>
    <p><br /></p>
  </div>
  </template>
  
  <script>
  export default {
    name: 'ParentRead3',
    data () {
      return {
        msg: 'Welcome to Your Vue.js App'
      }
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
    body {
      color: #555;
      margin-left: auto;
      margin-right: auto;
      line-height: 20px;
      font-size: 14px;
      font-family: 微软雅黑, sans-serif;
      text-indent: 28px;
    }
  
    h2{
      font-size: 16pt
    }
  
    li {
      text-indent: 2px;
    }
  
    blockquote {
      text-indent: 1px;
      color: silver;
    }
  
    strong {
      color: rgb(0, 180, 238);
    }
  
    @media screen and (max-width: 3600px) {
      body {
        width: 550px;
      }
    }
  
    img {
      width: 100%;
    }
  
    @media screen and (max-width: 500px) {
      body {
        width: 98%;
      }
    }
  </style>
  


// WEBPACK FOOTER //
// src/components/parentread/KeyPeroid3.vue